import { Button } from 'tuui';
import { FORM_MODES } from 'config/formModes';
import { useNavigate } from 'hooks';
import { usePermissions } from 'modules/taboola-common-frontend-modules/authentication/hooks/usePermissions';
import { ENTITY, PUSH_API_CREATOR_ROUTE_PATH } from '../../config';
import { generatePushApiReportFormPath } from '../../services/generatePushApiReportFormPath';

export const CreatePushApiButton = () => {
    const navigate = useNavigate();
    const isCreatePushApiPermitted = usePermissions('PUSH_API_ADMIN');

    return (
        <Button
            onClick={() => {
                navigate(
                    generatePushApiReportFormPath(PUSH_API_CREATOR_ROUTE_PATH, {
                        entity: ENTITY.PUSH_API,
                        mode: FORM_MODES.CREATE,
                    })
                );
            }}
            disabled={!isCreatePushApiPermitted}
        >
            + New API Integration
        </Button>
    );
};
